<div class="warning-popup-container">
    <div class="d-flex justify-content-between align-items-center border-bottom mb-3 px-2 pb-2">
        <h2 mat-dialog-title class="mb-0">{{data?.confirmation ? "Confirmation" : "Warning" }}</h2>
        <!-- <mat-icon mat-dialog-close>clear</mat-icon> -->
    </div>

    <mat-dialog-content class="mat-typography">
        <div class="row mt-4">
          <p class="text-center m-0 mb-2 main-text">Are you sure you want to exit?</p>
          <p class="text-center sub-text" *ngIf="isTask">Task will move into exception</p>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="d-flex justify-content-center warning-dialog">
        <div>
            <button mat-flat-button class="btn-outlined" (click)="closeDialog('0')">No</button>
            <button mat-flat-button class="mr-2 btn-main" (click)="closeDialog('1')" >Yes</button>
        </div>
    </mat-dialog-actions>
</div>
